import { useEffect } from 'react';

import { ESCAPE_KEY } from './constants';
import type { UseEscapeToDismissParams } from './types';

const useEscapeToDismiss = ({ onDismiss }: UseEscapeToDismissParams): void => {
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === ESCAPE_KEY) {
                onDismiss();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [onDismiss]);
};

export default useEscapeToDismiss;
